export default "__VITE_ASSET__CEg$tjKK__"